import { Spin, Typography } from 'antd'
import { CustomFieldEntity, Report } from 'shared'
import { MetadataListFormItemsProps } from './types'
import React from 'react'
import CIMSFormItem from '../../../../CIMSFormItem'
import HelpIcon from '../../../../HelpIcon'
import CIMSSelect from '../../../../CIMSSelect'
import { useReportRecordSelectContext } from '../../../../CIMSSelect/common/ReportRecordSelect/ReportRecordSelectContext'
import { useCustomFieldEntityRecordSelectContext } from '../../../../CIMSSelect/common/CustomFieldEntityRecordSelect/CustomFieldEntityRecordSelectContext'

const MetadataListFormItems: React.FC<MetadataListFormItemsProps> = ({
  inputKey,
  canEdit,
  disabled,
  customField: {
    metadata,
    customFieldToClassType: { required },
    id,
    name,
    description,
  },
}) => {
  const entities = useCustomFieldEntityRecordSelectContext()
  const reports = useReportRecordSelectContext()
  const metadataKey = inputKey === 'entityId' ? 'entityIds' : 'reportIds'
  return (
    <Spin spinning={entities.loading || reports.loading}>
      <Typography.Paragraph>
        <HelpIcon text={description}>{name}</HelpIcon>
      </Typography.Paragraph>
      <div style={{ marginLeft: '1rem' }}>
        {(metadata?.[metadataKey] ?? []).map((keyId) => {
          const related =
            inputKey === 'entityId'
              ? CustomFieldEntity.fromId(keyId)?.type
              : Report.fromId(keyId)?.name
          const options =
            inputKey === 'entityId'
              ? entities.getOptions(CustomFieldEntity.fromIdOrFail(keyId))
              : reports.options(Report.fromIdOrFail(keyId).classType)
          const name = inputKey === 'entityId' ? 'entities' : 'reports'
          return (
            <CIMSFormItem
              key={`${inputKey}-${keyId}`}
              label={related}
              disabled={disabled}
              requiredMessage={
                required
                  ? `Please enter a record for the ${related}`
                  : undefined
              }
              name={['customFields', id, name, keyId]}
            >
              <CIMSSelect disabled={!canEdit} options={options} />
            </CIMSFormItem>
          )
        })}
      </div>
    </Spin>
  )
}

export default MetadataListFormItems
